import { ANCHOR_PATTERNS_BY_LABEL, type NodeLabel } from '@atbash-labs/ontology-core'
import { strayPredicateForLabel } from './stray'

/**
 * Eager per-label stray counts for the Model browser rail badges.
 *
 * One UNION ALL arm per label with a non-empty `ANCHOR_PATTERNS_BY_LABEL`
 * entry (stray-exempt labels are omitted — they never badge). Each arm is
 * an indexed label scan + the same one-hop NOT-exists predicate used by
 * `plantLabelEntitiesCypher` when `stray = 'stray'`.
 */
function buildStrayCountsCypher(): string {
  const arms: string[] = []
  for (const label of Object.keys(ANCHOR_PATTERNS_BY_LABEL).sort() as NodeLabel[]) {
    const predicate = strayPredicateForLabel('n', label)
    if (predicate === null) continue
    arms.push(`
      MATCH (n:\`${label}\`)
      WHERE n.id IS NOT NULL
        AND (
          ${predicate}
        )
      RETURN '${label}' AS label, count(n) AS total`)
  }
  if (arms.length === 0) {
    return `RETURN '' AS label, 0 AS total LIMIT 0`
  }
  return arms.join('\n    UNION ALL\n')
}

export const PLANT_STRAY_COUNTS_CYPHER = buildStrayCountsCypher()
